import {Exceptions, ExceptionsAPI, OpeningHours, OpeningHoursAPI} from "../types/OpeningHoursNew";

/**
 * Transform opening hours exceptions from to array structure with ids
 * @param openingHours
 */
export function transformOpeningHours(openingHours: OpeningHoursAPI): OpeningHours {
  const exceptions: Exceptions = Object.entries(openingHours.exceptions).map(([dateRange, timeRanges]) => {
    return { id: crypto.randomUUID(), dateRange, timeRanges };
  });

  return {...openingHours, exceptions};
}

/**
 * Transform opening hours exceptions to object structure for the API
 * @param openingHours
 */
export function transformOpeningHoursForAPI(openingHours: OpeningHours): OpeningHoursAPI {
  // Convert exceptions array object
  const exceptions: ExceptionsAPI = Object.fromEntries(openingHours.exceptions.map(({dateRange, timeRanges}) => {
    return [dateRange, timeRanges];
  }));

  return {...openingHours, exceptions};
}